"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var KEYS = {
    8: 'onBackspace',
    9: 'onTab',
    13: 'onEnter',
    27: 'onEsc',
    32: 'onSpace',
    37: 'onLeft',
    38: 'onUp',
    39: 'onRight',
    40: 'onDown',
    188: 'onComma',
    16: 'onShift'
};
var Keyboard = /** @class */ (function (_super) {
    tslib_1.__extends(Keyboard, _super);
    function Keyboard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onKeyDown = function (event) {
            var _a;
            var rest = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                rest[_i - 1] = arguments[_i];
            }
            var onKeyDown = _this.props.onKeyDown;
            var key = event.keyCode ? event.keyCode : event.which;
            var callbackName = KEYS[key];
            if (callbackName && _this.props[callbackName]) {
                (_a = _this.props)[callbackName].apply(_a, tslib_1.__spreadArrays([event], rest));
            }
            if (onKeyDown) {
                onKeyDown.apply(void 0, tslib_1.__spreadArrays([event], rest));
            }
        };
        return _this;
    }
    Keyboard.prototype.componentDidMount = function () {
        var target = this.props.target;
        if (target === 'document') {
            document.addEventListener('keydown', this.onKeyDown);
        }
    };
    Keyboard.prototype.componentWillUnmount = function () {
        var target = this.props.target;
        if (target === 'document') {
            document.removeEventListener('keydown', this.onKeyDown);
        }
    };
    Keyboard.prototype.render = function () {
        var _a = this.props, children = _a.children, target = _a.target;
        return target === 'document'
            ? children
            : React.cloneElement(React.Children.only(children), {
                onKeyDown: this.onKeyDown
            });
    };
    return Keyboard;
}(React.Component));
var KeyboardWrapper = Keyboard;
exports.Keyboard = KeyboardWrapper;
//# sourceMappingURL=Keyboard.js.map